export default class FilterOption {
  static FREE_CANCELLATION = 'free-cancellation'
  static POINTS = 'points'
  static BREAKFAST = 'breakfast'
  static ACCESSIBLE_ROOMS = 'accessible-rooms'
  static PACKAGES = 'packages'

  static freeCancellation ({ order, selected }) {
    return new FreeCancellationFilterOption({ order, selected })
  }

  static points ({ order, selected }) {
    return new PointsFilterOption({ order, selected })
  }

  static breakfast ({ order, selected }) {
    return new BreakfastFilterOption({ order, selected })
  }

  static accessibleRooms ({ order, selected }) {
    return new AccessibleRoomsFilterOption({ order, selected })
  }

  static packages ({ order, selected }) {
    return new PackagesFilterOption({ order, selected })
  }

  constructor ({ code, label, order, selected, matches }) {
    this.code = code
    this.label = label
    this.order = order
    this.selected = selected || false
    this.matches = matches || 0
  }

  updateCounter = (matches) => this.copy({ matches })
  select = () => this.copy({ selected: true })
  unselect = () => this.copy({ selected: false })
  match (stay) {}
  copy = (partial) => {}
}

export class FreeCancellationFilterOption extends FilterOption {
  constructor ({ order, selected, matches }) {
    super({ code: FilterOption.FREE_CANCELLATION, label: 'rdFilterFreeCancellation', order, selected, matches })
  }

  match = (stay) => stay.isFreeCancellation()
  copy = (partial) => new FreeCancellationFilterOption({ ...this, ...partial })
}

export class PointsFilterOption extends FilterOption {
  constructor ({ order, selected, matches }) {
    super({ code: FilterOption.POINTS, label: 'rdFilterPoints', order, selected, matches })
  }

  match = (stay) => stay.hasPoints()
  copy = (partial) => new PointsFilterOption({ ...this, ...partial })
}

export class BreakfastFilterOption extends FilterOption {
  constructor ({ order, selected, matches }) {
    super({ code: FilterOption.BREAKFAST, label: 'rdFilterBreakfastIncluded', order, selected, matches })
  }

  match = (stay) => stay.hasBreakfastIncluded()
  copy = (partial) => new BreakfastFilterOption({ ...this, ...partial })
}

export class AccessibleRoomsFilterOption extends FilterOption {
  constructor ({ order, selected, matches }) {
    super({ code: FilterOption.ACCESSIBLE_ROOMS, label: 'rdFilterAccessibleRooms', order, selected, matches })
  }

  match = (stay) => stay.isAccessible()
  copy = (partial) => new AccessibleRoomsFilterOption({ ...this, ...partial })
}

export class PackagesFilterOption extends FilterOption {
  constructor ({ order, selected, matches }) {
    super({ code: FilterOption.PACKAGES, label: 'rdFilterPackages', order, selected, matches })
  }

  match = (stay) => stay.isPackage()
  copy = (partial) => new PackagesFilterOption({ ...this, ...partial })
}
